<template>
    <div>

        <b-modal id="create-or-update-relation-info" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
            <employee-relative-information-create-or-update v-model="relative" :errors="errors"></employee-relative-information-create-or-update>
            <template #modal-footer><v-executer  :editing="editing" :action="createOrUpdate"></v-executer></template>
        </b-modal>
    
        <v-table    ref="table"
                    search
                    up-class="px-1 pb-1"
                    with-items
                    :items="value"
                    name="employee-relative-information"
                    :add-callback="createNew"
                    :buttons="buttons"
                    overlay-class="pb-0"
                    :fields="fields"></v-table>

    </div>
</template>

<script>
import EmployeeRelativeInformationCreateOrUpdate from './EmployeeRelativeInformationCreateOrUpdate.vue'
import randomatic from 'randomatic'

export default {
    components:{
        EmployeeRelativeInformationCreateOrUpdate,
    },
    props:{
        value:Array,
        id:[String,Number]
    },
    data(){
        return{
            fields:[
                {name:"Adı",key:"FirstName",thClass:"w-25"},
                {name:"Soyadı",key:"LastName",thClass:"w-25"},
                {name:"Telefon",key:"PhoneNumber",thClass:"w-25"},
                {name:"Yakınlık Derecesi",key:"EmployeeRelationDegreeName",thClass:"w-25"},
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            errors:{},
            relative:{
                Id:null,
                EmployeeRelationDegreeName:null,
                EmployeeRelationDegreeId:null,
                FirstName:null,
                LastName:null,
                PhoneNumber:null,
                EmployeeId:null,
            },
            editing:false,
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.relative.Id = null
            this.relative.EmployeeRelationDegreeName = null
            this.relative.EmployeeRelationDegreeId = null
            this.relative.FirstName = null
            this.relative.LastName = null
            this.relative.PhoneNumber = null
            this.relative.EmployeeId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update-relation-info')
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.relative.Id = item.Id
            this.relative.FirstName = item.FirstName
            this.relative.LastName = item.LastName
            this.relative.PhoneNumber = item.PhoneNumber
            this.relative.EmployeeRelationDegreeName = item?.EmployeeRelationDegreeName || null
            this.relative.EmployeeRelationDegreeId = item.EmployeeRelationDegreeId
            this.relative.EmployeeId = item.EmployeeId
            this.$showModal('create-or-update-relation-info')
        },
        validation(){
            let count = 0
            if(this.$isNullOrEmpty(this.relative.EmployeeRelationDegreeId)){
                this.$set(this.errors,'EmployeeRelationDegreeId','Yakınlık derecesi alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.relative.FirstName)){
                this.$set(this.errors,'FirstName','Ad alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.relative.LastName)){
                this.$set(this.errors,'LastName','Soyad alanı zorunludur.')
                count ++
            }
            if(this.$isNullOrEmpty(this.relative.PhoneNumber)){
                this.$set(this.errors,'PhoneNumber','Telefon alanı zorunludur.')
                count ++
            }
            return count > 0 ? false : true
        },
        createOrUpdate(){
            if(this.validation()){
                if(this.relative.Id){
                    let item = this.value.find(r=> r.Id == this.relative.Id)
                    this.$set(item,"FirstName",this.relative.FirstName)
                    this.$set(item,"LastName",this.relative.LastName)
                    this.$set(item,"PhoneNumber",this.relative.PhoneNumber)
                    this.$set(item,"EmployeeRelationDegreeName",this.relative.EmployeeRelationDegreeName)
                    this.$set(item,"EmployeeRelationDegreeId",this.relative.EmployeeRelationDegreeId)
                    this.$set(item,"EmployeeId",this.relative.EmployeeId)
                    this.$set(item,"Unsaved",true)
                }else{
                    this.value.push({
                        Id:randomatic("A0",10),
                        EmployeeId: this.id,
                        FirstName:this.relative.FirstName,
                        LastName:this.relative.LastName,
                        PhoneNumber:this.relative.PhoneNumber,
                        EmployeeRelationDegreeName:this.relative.EmployeeRelationDegreeName,
                        EmployeeRelationDegreeId:this.relative.EmployeeRelationDegreeId,
                        Unsaved:true
                    })
                }
                this.$hideModal('create-or-update-relation-info')
            }
        },
        delete(item,key,index){
            this.$confirm("Silmek istediğinize emin misiniz?",`Bu işlem ${item.FirstName} ${item.LastName} isimli yakını silecektir ve geri alınamaz.`).then(res=>{
                if(res){
                    this.$delete(this.value,index)
                }
            })
        },
    }
}
</script>

<style>

</style>